<template>
  <span>
    {{ total }}
  </span>
</template>

<script>
import { Currency, getShopTotal } from './utils'

export default {
  props: {
    value: Object,
    currency: String,
  },
  computed: {
    total() {
      return Currency(getShopTotal(this.value), { currency: this.currency })
    },
  },
}
</script>
